import { use_slice_generation } from '@/hooks/store/use_slices';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';

export function HOOK__tools_is_selected(tool: DTO__generation_tool) {
  const { generation_current } = use_slice_generation(['generation_current']);

  if (generation_current.is_stub()) return false;

  return tool._id == generation_current.tool._id;
}
